// extracted by mini-css-extract-plugin
module.exports = {"block":"NoData_block__2Z5G_","content":"NoData_content__3igT3","img":"NoData_img__vThq3","title":"NoData_title__TBBR2","btn":"NoData_btn__N4Bsh"};